<script>
import { Line } from 'vue-chartjs';
export default {
    extends: Line,
    props: {
        data: {
            type: Object,
            default: () => { return {} }
        },
        options: {
            type: Object,
            default: () => { return {} }
        }
    },
    mounted () {
        this.render();
    },
    methods: {
        render() {
            this.renderChart(this.data, this.options);
        }
    },
    watch: {
        data: function(newData) {
            this.render();
        },
        options: function(newOptions) {
            this.render();
        }
    }
}
</script>
